import React, { useContext, useState } from 'react';
//Siempre context se trae con {} porque es un objeto
import { CategoriesContext } from '../context/CategoriesContext';
import { RecipesContext } from '../context/RecipesContext';

const Form = () => {

    const [search, saveSearch] = useState('');

    const { categories } = useContext(CategoriesContext);

    const { searchRecipe, getConsult } = useContext(RecipesContext);

    const getResultRecipe = (e) => {
        saveSearch({
            ...search,
            [e.target.name]: e.target.value
        });
    };

    return (
        <form className="col-12"
            onSubmit={e => {
                e.preventDefault();
                searchRecipe(search);
                getConsult(true);
            }}
        >
            <fieldset className="text-center">
                <legend>Busca bebidas por categoría o Ingrediente </legend>
            </fieldset>
            <div className="row mt-4">
                <div className="col-md-4">
                    <input
                        name="name"
                        className="form-control"
                        type="text"
                        placeholder="Busca por ingrediente"
                        onChange={getResultRecipe}
                    ></input>
                </div>
                <div className="col-md-4">
                    <select
                        className="form-control"
                        name="category"
                        onChange={getResultRecipe}
                    >
                        <option value="">- Selecciona categoría -</option>
                        {categories.map(category => (
                            <option
                                key={category.strCategory}
                                value={category.strCategory}
                            >
                                {category.strCategory}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4">
                    <input
                        className="btn btn-block btn-primary"
                        type="submit"
                        value="Buscar bebidas"
                    ></input>
                </div>
            </div>
        </form>
    );
}

export default Form;